// src/components/BackToTopFab.jsx
//
// Floating "scroll to top" FAB that appears once the user has scrolled
// past a threshold. Listens on the nearest scrollable ancestor (the
// Layout's main content Box), falling back to window scroll.
// Positioned above the mobile bottom nav so it never overlaps.

import React, { useEffect, useState } from 'react';
import { Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp as UpIcon } from '@mui/icons-material';
import { BOTTOM_NAV_HEIGHT } from './MobileBottomNav';

const BackToTopFab = ({ threshold = 400, targetSelector = '#main-content' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el =
      (targetSelector && document.querySelector(targetSelector)) || window;
    const getY = () =>
      el === window ? window.scrollY || window.pageYOffset : el.scrollTop;
    const onScroll = () => setVisible(getY() > threshold);
    onScroll();
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [threshold, targetSelector]);

  const scrollToTop = () => {
    const el =
      (targetSelector && document.querySelector(targetSelector)) || window;
    if (el === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Zoom in={visible} unmountOnExit>
      <Fab
        size="medium"
        color="primary"
        onClick={scrollToTop}
        aria-label="Back to top"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: {
            xs: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px) + 16px)`,
            md: 24,
          },
          zIndex: (t) => t.zIndex.speedDial,
        }}
      >
        <UpIcon />
      </Fab>
    </Zoom>
  );
};

export default BackToTopFab;
